<template>
  <div>
    <Row justify="start" type="flex">
      <Col class="buy_col01" v-for="(item, index) in photoArr1" :key="index">
        <div class="buy_rule" @click="getMoney(item)">
          <img :src="item.photoUrl" alt="#" />
        </div>
        <div @click="getMoney(item)" class="sp">{{ item.ref }}</div>
        <div style="font-size: 18px; color: #f12344; margin-bottom: 6px">
          <!--{{item.money}}-->
          <Button type="primary" @click="getMoney(item)">了解更多</Button>
        </div>
      </Col>
    </Row>
    <!--对话框-->
    <div>
      <Modal
        class="modal_div"
        v-model="modal1"
        :title="ref"
        width="830px"
        class-name="vertical-center-modal"
        @on-visible-change="onChange"
      >
        <div slot="header">
          <Row>
            <Col span="20">
              <span class="header_div">{{ this.ref }}</span>
            </Col>
            <!-- <Col span="3">
              <Button type="primary" @click="goBuyGo">立即购买</Button>
            </Col> -->
          </Row>
        </div>
        <div class="wid_img">
          <div>
            <img :src="item01.photoUrl" alt="暂无图片" />
          </div>
          <div class="Introduction">
            <div class="Introduction__p">介 绍：{{ item01.p }}</div>
            <div class="phone">
              咨询电话: <span style="color: #1966ff"> 18001306738</span>
            </div>
          </div>
        </div>
        <div slot="footer">
          <Button @click="modal1 = false">取消</Button>
        </div>
      </Modal>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      modal1: false,
      item01: [],
      ref: "",
      profile: "",
      VRImg: "",
      photoArr1: [
        // 体验区讲评台
        {
          photoUrl: "../../../static/img/photo/speech.jpg",
          p: " 1、通过作业内容交底后，让班组长结合当班所需作业的任务，指出作业人员施工期间安全防范事项，让作业人员明确在自己的岗位上，该做什么工作，该怎么做及安全相关要求。2、针对现场施工条件、作业人员工作状态，对当班作业中可能出现的不安全因素进行危险提醒，达到上岗作业前再次告诫该注意哪些方面、存在哪些不安全因素、如何预防事故的发生等等，使作业人员对作业环境的不安全因素有充分的认识，做到'防患于未然'",
          ref: "体验区讲评台",
          money: "￥20000.00",
        },
        //安全帽撞击体验
        {
          photoUrl: "../../../static/img/photo/Theimpact.jpg",
          p: " 安全帽正确佩戴方法，使职工认识到正确佩戴安全帽是一种责任。体验佩戴安全帽对物体打击所减轻的效果。切实感受到安全帽受到坠落物、硬质物体的冲击及挤压时，减少冲击力，减轻对人体头部伤害的重要作用。",
          money: "￥",
          ref: "安全帽撞击体验",
        },
        //安全网对比展示
        {
          photoUrl: "../../../static/img/photo/photo_safety.png",
          p:
            "VR安全体验馆是通过电脑模拟，占地空间小。体验人员通过虚拟环境了解体验项目，不能亲身接触。主要应用于企事业单位、学校、社区等场所。\n" +
            "主要作用:\n" +
            "将施工安全教育与体验相结合，对施工人员进行安全教育时，通过亲身体验各种安全防护用品的使用及出现危险瞬间的感受，增强施工人员在施工现场时的切身感受，让安全理念深入人心，有效加强施工人员的安全意识。",
          ref: "安全网对比展示",
          money: "¥2000.00",
        },
        //搬运重物体验
        {
          photoUrl: "../../../static/img/photo/photo_move.jpg",
          p:
            "重物体验的应用和作用：　\n" +
            "1、在工作之前，应该做好热身运动，减少瞬间扭伤拉伤，。\n" +
            "2、体验时要双手均衡抓取，达到锻炼身体，掌握面对重物时的正确搬运方法。",
          ref: "搬运重物体验",
          money: "¥800.00",
        },
        //人字梯体验
        {
          photoUrl: "../../../static/img/photo/photo_ladder.jpg",
          p: "功能：通过人字梯体验，教育不正确使用人字梯时可能出现倾倒的危险性，学习合格人字梯的标准及正确使用方法，提高自我保护意识。",
          ref: "人字梯体验",
          money: "¥4500.00",
        },
        //爬梯体验
        {
          photoUrl: "../../../static/img/photo/photo_stand.jpg",
          p:
            "让体验者感受攀爬劣质爬梯带来的严重后果，所以爬梯根据每个人的特点，设定合理的步距，" +
            "攀爬起来舒适安全，安装牢固，使用材料合格，避免采用锈蚀劣质产品，防腐处理，科学的施工维护，给施工带来方便与安全。",
          ref: "爬梯体验",
          money: "¥4000.00",
        },
        //钢丝绳展示
        {
          photoUrl: "../../../static/img/photo/photo_steel.jpg",
          p:
            "规格：2000*2400" +
            "主要材质及内容：全部使用1.2mm厚钢板折弯搭配50*50*3.0mm以及40*40*2.5mm镀锌钢方管焊接而成\n" +
            "功能：通过现场学习各种钢丝绳的使用方法及不合格钢丝绳的报废条件\n" +
            "含钢丝绳捆绑",
          ref: "钢丝绳展示",
          money: "¥4000.00",
        },
        //劳保用品展示柜
        {
          photoUrl: "../../../static/img/photo/photo_labour.jpg",
          p:
            "规格：1000*1000*2000\n" +
            "1000*900*900\n" +
            "结构：镀锌方钢、镀锌板 5mm白玻\n" +
            "外观：喷漆+喷绘\n" +
            "假人及各种劳保用品\n" +
            "功能：展示各种合格劳保用品，加强员工的劳动保护概念，劳保用品不是来应付检查的，只有合格的产品才能真正起到保护作用。",
          ref: "劳保用品展示柜",
          money: "¥8000.00",
        },
        //电焊作业体验
        {
          photoUrl: "../../../static/img/photo/photo_electrowelding.png",
          p:
            "规格：1500*2300\n" +
            "主要材质及内容：方管、模板以及电焊机配套设备\n" +
            "功能：本体验设施在体验时模拟电焊作业，近距离体验电焊作业，以此警示从事电焊施工的作业者要以严肃的态度对待工作，同时警示每一位建筑工程参与者首先要注意保护自己，远离危险源。",
          ref: "电焊作业体验",
          money: "¥3000.00",
        },
        //灭火器演示体验
        {
          photoUrl: "../../../static/img/photo/photo_annihilator.jpg",
          p:
            "规格：4000*800*2200\n" +
            "主要材质及内容：1.2mm镀锌钢板和50*50*3.0mm以及40*40*2.5mm镀锌钢管焊接而成\n" +
            "功能：灭火器演示体验包含设备模拟烟雾及灭火器等，含带遥控装置",
          ref: "灭火器演示体验",
          money: "¥7500.00",
        },
        //安全急救培训体验
        {
          photoUrl: "../../../static/img/photo/photo_train.jpg",
          p:
            "规格：2400*800*2300\n" +
            "主要材质及内容：镀锌板搭镀锌管构架，心肺复苏模型使用高科技驱动的教学模拟病人；外罩和急救床使用镀锌管构架，心肺复苏模型使用高科技驱动的教学模拟病人\n" +
            "功能：劳动过程中心脏骤停现象并不罕见，心脏骤停后几分钟病人就会死亡，如果病人能在第一时间得到心肺复苏就会大大增加生还的希望，并为后续专业医务人员的进一步医治赢得宝贵的时间",
          ref: "安全急救培训体验",
          money: "¥9500.00",
        },
        //安全综合用电体验
        {
          photoUrl: "../../../static/img/photo/photo_electro-.jpg",
          p:
            "规格：4000*1200*2300\n" +
            "主要材质及内容：\n" +
            "镀锌方管框架，整体为组装式。外形光线美观，CI喷绘户外写真宣传。\n" +
            "基本常见用电设备配置展示，并有触电感应仪一套。\n" +
            "功能：体验者还能亲自感受安全电流流经人体的感觉，让体验者知晓超强电流的杀伤力是人类无法抵御的，正确引导学习安全用电的知识。",
          ref: "安全综合用电体验",
          money: "¥8000.00",
        },
        //安全区大门
        {
          photoUrl: "../../../static/img/photo/photo_door.jpg",
          p:
            "规格：4000*400*3500  立柱400 \n" +
            "主要材质及内容：镀锌方钢、镀锌板，40*40与30*30镀锌方管焊接拼接组成外包裹加厚喷绘布，法兰片膨胀螺丝固定\n" +
            "功能：引导观摩，体验及学习者进去体验区。",
          ref: "安全区大门",
          money: "¥5500.00",
        },
        // 安全带高空体验
        {
          photoUrl: "../../../static/img/photo/安全带高空体验.png",
          p: "体验安全带的正确使用及佩戴安全带下坠后人体的瞬间感受。",
          ref: "安全带高空体验",
          money: "",
        },
        // 安全警示牌
        {
          photoUrl: "../../../static/img/photo/安全警示牌.png",
          p: "让劳动者学会辨别安全标识，通过安全标识判断危险源的存在，保护劳动人员自身生命安全",
          ref: "安全警示牌",
          money: "",
        },
        // 安全宣传栏
        {
          photoUrl: "../../../static/img/photo/安全宣传栏.png",
          p: "学习各种安全知识",
          ref: "安全宣传栏",
          money: "",
        },
        // 不锈钢介绍牌
        {
          photoUrl: "../../../static/img/photo/不锈钢介绍牌.png",
          p: "",
          ref: "不锈钢介绍牌",
          money: "",
        },
        // 嫡灯架展示
        {
          photoUrl: "../../../static/img/photo/嫡灯架展示.png",
          p: "如何正确使用镝灯及预防镝灯对人体伤害的知识。夜间照明使用镝灯相当普遍，然而镝灯一旦使用不当，其释放的紫外线将会对劳动者的眼睛造成不良的影响，严重的可能引发电光性眼炎",
          ref: "嫡灯架展示",
          money: "",
        },
        // 吊运作业体验
        {
          photoUrl: "../../../static/img/photo/吊运作业体验.png",
          p: "吊运作业体验是指通过模拟吊装操作过程，让参与者了解吊装作业的流程、安全规范和危险因素。体验通常会提供专业设备和工具，如吊车、钢丝绳、夹具等，并由资深操作员进行指导和监督。参与者可以在安全的环境下亲身感受吊装操作的难度和重要性，加深对吊装作业的理解和认识。这种体验通常用于职业培训、安全教育和娱乐活动中。",
          ref: "吊运作业体验",
          money: "",
        },
        // 洞口坠落体验
        {
          photoUrl: "../../../static/img/photo/洞口坠落体验.png",
          p: "",
          ref: "洞口坠落体验",
          money: "",
        },
        // 仿真草坪
        {
          photoUrl: "../../../static/img/photo/仿真草坪.png",
          p: "仿真草坪是一种人造草坪，通常采用聚乙烯或聚丙烯等合成材料制成。它具有类似天然草坪的外观和触感，但不需要灌溉、施肥和修剪等维护工作，可以大幅降低草坪维护成本。同时，仿真草坪还具有良好的耐候性和防水性能，在户外环境中可以长期保持美观和实用。",
          ref: "仿真草坪",
          money: "",
        },
        // 感应式语音讲解器
        {
          photoUrl: "../../../static/img/photo/感应式语音讲解器.png",
          p: "感应式语音讲解器是一种集语音合成、感应控制等技术于一体的电子设备。它可以通过接收触摸或感应信号，自动播放预设的语音提示或讲解内容，以实现对场馆、博物馆、展馆等公共场所的导览和讲解。感应式语音讲解器通常具有多种语言选择功能，并可根据不同的参观路线和内容设置不同的语音提示，以提高便利性。",
          ref: "感应式语音讲解器",
          money: "",
        },
        // 空压机、防爆管等供气设备
        {
          photoUrl: "../../../static/img/photo/空压机、防爆管等供气设备.png",
          p: "空压机可以将空气压缩成高压气体，用于驱动各类气动工具和设备,防爆管是一种特殊材质制造的管道，能够有效地防止管内气体发生火花或引起爆炸,空压机和防爆管的使用不仅能够提高工作效率，降低人力成本，而且还能保障施工现场的安全性和稳定性，减少劳动事故的发生。",
          ref: "空压机、防爆管等供气设备",
          money: "",
        },
        // 临边倚靠倾斜
        {
          photoUrl: "../../../static/img/photo/临边倚靠倾斜.png",
          p: "体验者靠在栏杆上会有一个突然倾斜的遭遇，通过这个遭遇警示员工施工楼层的临时防护栏杆也有不安全的因素，远离危险源就是对自己生命最好的保护（带遥控装置）",
          ref: "临边倚靠倾斜",
          money: "",
        },
        // 马道对比体验
        {
          photoUrl: "../../../static/img/photo/马道对比体验.png",
          p: "通过在架体上的行走体验，使工作人员识别正确马道和不良马道、良好通道和不良通道之间的区别。良好马道设置目的是为了便于施工人员的人行通道，便于小型机械物资转运。严禁使用有明显变形、裂纹和严重锈蚀的钢管扣件并做好警示工作。",
          ref: "马道对比体验",
          money: "",
        },
        // 平衡木体验
        {
          photoUrl: "../../../static/img/photo/平衡木体验.png",
          p: "平衡木是体验自身平衡能力及动作的正确性，检查肢体的应变能力，检测作业人员是否满足作业条件。（身体不适者应停止危险作用）",
          ref: "平衡木体验",
          money: "",
        },
        // 墙体坍塌体验
        {
          photoUrl: "../../../static/img/photo/墙体坍塌体验.png",
          p: "本体验设施在体验时模拟倒塌瞬间倾翻，近距离体验甚至会将体验者拍倒，场面感觉非常逼真危险，以此警示从事墙体砌筑施工的作业者要以严肃的态度对待工作，百年大计，质量为本，每一位建筑施工参与者都要努力建造合格的建筑产品，以免造成严重的建筑事故",
          ref: "墙体坍塌体验",
          money: "",
        },
        // 消防展示
        {
          photoUrl: "../../../static/img/photo/消防展示.png",
          p: "消防器材是保障施工现场安全的重要装备，提高现场消防应急和自救能力",
          ref: "消防展示",
          money: "",
        },
        // 移动操作平台倾斜体验
        {
          photoUrl: "../../../static/img/photo/移动操作平台倾斜体验.png",
          p: "演练活动平台在稳定状态不佳的平台上方吊装建筑材料会大大增加倾覆的概率，让体验者领略到平台倾斜时恐怖心理，引导员工正确使用移动脚手架和活动平台",
          ref: "移动操作平台倾斜体验",
          money: "",
        },
      ],
    };
  },

  methods: {
    onChange() {
      document
        .querySelector("body")
        .setAttribute("style", "overflow:hidden;padding-right:15px");
    },
    /*弹出对话框*/
    getMoney(item) {
      this.modal1 = true;
      this.item01 = item;
      this.ref = item.ref;
      this.profile = item.p;
      this.VRImg = item.VRImg;
    },
    /*刚进页面的立即购买*/
    getMoney01(item) {
      this.goBuy(item);
    },
    /*弹出框里面立即购买*/
    goBuyGo() {
      this.modal1 = false;
      this.goBuy(this.item01);
      document.querySelector("body").setAttribute("style", "overflow:auto");
    },
    /*购买*/
    goBuy(item) {
      sessionStorage.setItem("title", item.title);
      sessionStorage.setItem("belong", item.belong);
      sessionStorage.setItem("path", item.path);
      sessionStorage.setItem("money", item.money);
      sessionStorage.setItem("ref", item.ref);
      sessionStorage.setItem("photoUrl1", item.photoUrl1);
      sessionStorage.setItem("classify", JSON.stringify(item.classify));
      this.$router.push({
        path: "/home/buyGo",
      });
    },
  },
};
</script>
<style>
.modal_div .ivu-modal-header p,
.modal_div .ivu-modal-header-inner {
  color: #02a0e7;
  font-size: 20px;
  font-weight: bold;
  font-family: 新宋体, serif;
}

/*面包屑*/
.col_bread .ivu-breadcrumb {
  font-size: 16px;
}
</style>
<style scoped>
/*弹出框字体*/
.header_div {
  color: #02a0e7;
  font-size: 20px;
  font-weight: bold;
  font-family: 新宋体, serif;
}

.font_size {
  white-space: pre-wrap;
}

.buy_col01 {
  border-radius: 6px;
  width: 270px;
  background: #ffff;
  text-align: center;
  cursor: pointer;
  margin: 14px 0px 0 22px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.2);
  border-radius: 6px;
}

.buy_col01:hover {
  box-shadow: 0 0 3px 3px rgba(0, 0, 0, 0.2);
}

.buy_col01 .sp:hover {
  color: red;
}

.buy_rule {
  width: 270px;
  height: 240px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.buy_rule img {
  width: 210px;
  height: 210px;
}

.sp {
  font-size: 14px;
  height: 40px;
}

.wid_img {
  display: flex;
  /* justify-content: center; */
  align-items: center;
}

.wid_img img {
  width: 364px;
  height: 263px;
}

.Introduction {
  width: 364px;
  height: 263px;
  margin-left: 15px;
}

.Introduction__p {
  margin-top: 15px;
}

.buy_rule img:hover {
  animation: move 0.5s linear forwards;
}

@keyframes move {
  0% {
    transform: scale(1);
  }

  100% {
    transform: scale(1.1);
  }
}

.phone {
  margin-top: 5%;
}
</style>



// WEBPACK FOOTER //
// src/components/Buy/Experience.vue